<div [class.offer-form-page]="!embedded">
  @if (!embedded) {
    <app-prevention-group-header activeTab="offers"></app-prevention-group-header>
    <div class="breadcrumb-bar">
      <button class="breadcrumb-back" (click)="goToMyOffers()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        {{ 'preventionOffres.myOffers.back' | translate }}
      </button>
      <span class="breadcrumb-sep">·</span>
      <a class="breadcrumb-link" routerLink="/pilotage-prevention">{{ 'preventionOffres.myOffers.breadcrumb.prevention' | translate }}</a>
      <span class="breadcrumb-sep">·</span>
      <a class="breadcrumb-link" routerLink="/prevention-offres">{{ 'preventionOffres.myOffers.breadcrumb.offers' | translate }}</a>
      <span class="breadcrumb-sep">·</span>
      <span class="breadcrumb-current">
        {{ mode() === 'create' ? ('preventionOffres.offerForm.createBreadcrumb' | translate) : displayedOfferName() }}
      </span>
    </div>
  }
  @if (loadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.offerForm.loadError' | translate }}</div></div>
  } @else if (templateLoadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.offerForm.template.loadError' | translate }}</div></div>
  } @else if (loading()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.offerForm.loading' | translate }}</div></div>
  } @else {
    @if (mode() === 'edit') {
      <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px">
        <div class="ct">{{ displayedOfferName() }}</div>
        @if (!readOnlySig()) {
          <button class="btn-danger-sm" (click)="openArchiveConfirm()">{{ 'preventionOffres.myOffers.archive.button' | translate }}</button>
        }
      </div>
    } @else {
      <div class="ct" style="margin-bottom:16px">{{ 'preventionOffres.offerForm.createBreadcrumb' | translate }}</div>
    }

    @if (readOnlySig()) {
      <div class="card of-readonly-banner">{{ 'preventionOffres.offerForm.readOnlyBanner' | translate }}</div>
    }

    <!-- Remontée en tête de page (ajustement UI 2026-09-07) : action opérationnelle de premier plan,
         jamais enfouie sous les contenus éditoriaux (description/contenu patient/bilans). Ne modifie
         ni la route (goSites() inchangée) ni les données (activeSiteCount() déjà chargé pour le
         verrou bilans ci-dessous, aucun nouvel appel -- pas de total org disponible sur cette page
         sans appel supplémentaire, donc pas de "X / Y", seul X est affiché). -->
    @if (mode() === 'edit' && !embedded) {
      <div class="card of-sites-card">
        <div class="ct">{{ 'preventionOffres.offerForm.sites.title' | translate }}</div>
        <div class="of-sites-stat">
          {{ (activeSiteCount() > 1 ? 'preventionOffres.offerForm.sites.activeSitesCountPlural' : 'preventionOffres.offerForm.sites.activeSitesCountSingular') | translate: { count: activeSiteCount() } }}
        </div>
        <div class="cs" style="margin:6px 0 14px">{{ 'preventionOffres.offerForm.sites.subtitle' | translate }}</div>
        <button class="btn-sites-cta" (click)="goSites()">{{ 'preventionOffres.offerForm.sites.button' | translate }} →</button>
      </div>
    }

    <app-offer-form
      #formRef
      [mode]="mode()"
      [families]="families() ?? []"
      [bilans]="bilans() ?? []"
      [initialDetail]="offerDetail()"
      [initialTemplate]="resolvedTemplate()"
      [bilanCompositionLocked]="bilanCompositionLocked()"
      [activeSiteCount]="activeSiteCount()"
      [saving]="saving()"
      [serverError]="serverError()"
      [lockedAdditionalItem]="lockedAdditionalItem()"
      [readOnly]="readOnlySig()"
      (save)="onSave($event)">

      <!-- Empilées sous "Contenus supplémentaires" dans la colonne gauche du formulaire (voir
           [of-left-extra] dans offer-form.component.html), jamais en blocs pleine largeur séparés. -->
      @if (mode() === 'edit' || readOnlySig()) {
        <div class="card" of-left-extra>
          <div class="ct" style="margin-bottom:10px">{{ 'preventionOffres.offerForm.photo.title' | translate }}</div>
          <div style="display:flex;align-items:center;gap:12px">
            @if (photoUrl()) {
              <img [src]="photoUrl()" [attr.alt]="'preventionOffres.offerForm.photo.title' | translate" style="width:160px;aspect-ratio:16/9;border-radius:10px;object-fit:cover;background:#fff;border:1px solid var(--bd);flex-shrink:0">
            } @else {
              <div style="width:160px;aspect-ratio:16/9;border-radius:10px;background:var(--ps);border:1px solid var(--bd);display:flex;align-items:center;justify-content:center;font-size:11px;color:var(--mu);text-align:center;line-height:1.3;flex-shrink:0">{{ 'preventionOffres.offerForm.photo.noPhoto' | translate }}</div>
            }
            @if (!readOnlySig()) {
              <div>
                <div style="display:flex;align-items:center;gap:8px">
                  <label style="display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border-radius:8px;border:1px solid var(--bd);background:#fff;font-size:12px;font-weight:600;color:var(--ink);cursor:pointer" [class.disabled]="uploadingPhoto()">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    {{ (uploadingPhoto() ? 'preventionOffres.offerForm.photo.uploading' : (photoUrl() ? 'preventionOffres.offerForm.photo.changePhoto' : 'preventionOffres.offerForm.photo.importPhoto')) | translate }}
                    <input type="file" accept="image/png,image/jpeg,image/webp" style="display:none" [disabled]="uploadingPhoto()" (change)="onPhotoSelected($event)">
                  </label>
                  @if (photoUrl()) {
                    <button type="button" class="btn-danger-sm" (click)="openRemovePhoto()">{{ 'preventionOffres.offerForm.photo.remove' | translate }}</button>
                  }
                </div>
                <div style="font-size:10px;color:var(--mu);margin-top:5px">{{ 'preventionOffres.offerForm.photo.hint' | translate }}</div>
              </div>
            }
          </div>
        </div>
      }

    </app-offer-form>
  }
</div>

@if (showArchiveConfirm()) {
  <app-confirm-modal
    [title]="'preventionOffres.myOffers.archive.confirmTitle' | translate"
    [message]="archiveConfirmMessage()"
    [confirmText]="'preventionOffres.myOffers.archive.confirmButton' | translate"
    [cancelText]="'preventionOffres.myOffers.archive.cancelButton' | translate"
    [loading]="archiving()"
    [errorMessage]="archiveErrorMessage()"
    (confirm)="confirmArchive()"
    (cancel)="closeArchiveConfirm()">
  </app-confirm-modal>
}

@if (showLeaveConfirm()) {
  <app-confirm-modal
    [title]="'preventionOffres.offerForm.unsavedChanges.title' | translate"
    [message]="'preventionOffres.offerForm.unsavedChanges.message' | translate"
    [confirmText]="'preventionOffres.offerForm.unsavedChanges.confirmButton' | translate"
    [cancelText]="'preventionOffres.offerForm.unsavedChanges.cancelButton' | translate"
    (confirm)="confirmLeaveNavigation()"
    (cancel)="cancelLeaveNavigation()">
  </app-confirm-modal>
}

@if (removePhotoOpen()) {
  <app-confirm-modal
    [title]="'preventionOffres.offerForm.photo.removeModalTitle' | translate"
    [message]="'preventionOffres.offerForm.photo.removeModalMessage' | translate"
    [confirmText]="'preventionOffres.offerForm.photo.remove' | translate"
    [cancelText]="'preventionOffres.myOffers.archive.cancelButton' | translate"
    [loading]="removePhotoLoading()"
    [errorMessage]="removePhotoError()"
    (confirm)="confirmRemovePhoto()"
    (cancel)="closeRemovePhoto()">
  </app-confirm-modal>
}
